export const smallViewState = $state({
  visible: false,
  coverage: 0,
});
